import { ArrowRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useCallback, useContext } from 'react';

import './CustomerLeadStepStart.scss';

import LogoText from 'src/assets/logo-text.svg?react';
import StartVideoPoster from 'src/assets/start-page-video-poster.jpg';
import StartVideo from 'src/assets/start-page-video.mp4';
import { CustomerLeadStepper } from 'src/components/customers/steps/CustomerLeadStepper';
import { CustomersContext } from 'src/pages/CustomersPage/CustomersPage.context';
import { CustomerPageStep } from 'src/pages/CustomersPage/CustomersPage.context.types';

export function CustomerLeadStepStart() {
  const { customerLeadProduct, setCustomerStep } = useContext(CustomersContext);

  const isContinue = !!customerLeadProduct?.submittedFieldGroups.length;

  const handleStartClick = useCallback(() => setCustomerStep(CustomerPageStep.Quantities), [setCustomerStep]);

  return (
    <div className="customer-lead-step-start__layout">
      <div className="customer-lead-step-start__layout__left" />
      <div className="customer-lead-step-start__layout__center">
        <div className="customer-lead-step-start__layout__center__header">
          <div className="customer-lead-step-start__layout__center__header__logo">
            <div className="customer-lead-step-start__layout__center__header__logo-icon" />
            <LogoText className="customer-lead-step-start__layout__center__header__logo-text" />
          </div>
        </div>

        <div className="customer-lead-step-start__layout__center__content">
          <div className="customer-lead-step-start__layout__center__title">
            {isContinue ? 'Let’s continue!' : 'Let’s get started!'}
          </div>
          <div className="customer-lead-step-start__layout__center__text">
            Application process contains few steps which take around 5 minutes, Pictures are most required and most
            important
          </div>
          <div className="customer-lead-step-start__layout__center__stepper">
            <CustomerLeadStepper isStartPage={true} />
          </div>
          <div className="customer-lead-step-start__layout__center__footer">
            <Button
              className="customer-lead-step-start__layout__center__footer__start-button"
              type="primary"
              icon={<ArrowRightOutlined />}
              onClick={handleStartClick}
            >
              {isContinue ? 'Continue' : 'Start application'}
            </Button>
          </div>
        </div>
      </div>
      <div className="customer-lead-step-start__layout__right">
        <div className="customer-lead-step-start__video-container">
          <video
            controls={false}
            loop={true}
            autoPlay={true}
            playsInline={true}
            muted={true}
            poster={StartVideoPoster}
            disablePictureInPicture={true}
          >
            <source src={StartVideo} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
}
